import { TabBarSkeleton } from "@/components/TabBarSkeleton";
import { PartnerAnalyticsSkeleton } from "./components/PartnerAnalyticsSkeleton";

/**
 * Full-page skeleton for the Partner Detail route's pendingComponent.
 * Shows tab bar and the default Analytics tab skeleton.
 */
export function PartnerDetailPageSkeleton() {
	return (
		<div>
			<TabBarSkeleton tabWidths={[70, 160]} />
			<PartnerAnalyticsSkeleton />
		</div>
	);
}
